import _regeneratorRuntime from "/opt/www/game/xcp-vue-xcll/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/opt/www/game/xcp-vue-xcll/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import { oldRoleKeep } from "@/api/data";
import serverList from "../../../components/serverList/serverOptions.vue";
import DataOptions from "../../../components/timeList/dataOptions.vue";
import infoList from "@/mixins/infoList";
export default {
  mixins: [infoList],
  components: {
    serverList: serverList,
    DataOptions: DataOptions
  },
  data: function data() {
    return {
      listApi: oldRoleKeep,
      searchInfo: {
        server_id: []
      },
      formData: [this.$moment().subtract(7, "days").format("YYYY-MM-DD"), this.$moment().format("YYYY-MM-DD")]
    };
  },
  mounted: function mounted() {
    this.searchEvent();
  },
  methods: {
    loadTatleData: function loadTatleData() {
      var _this = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _this.loading = true;
              _context.next = 3;
              return _this.getTableData();
            case 3:
              //对 Table 进行重新布局。当 Table 或其祖先元素由隐藏切换为显示时，可能需要调用此方法
              //否则出现表格混乱
              _this.$refs["table"].doLayout();
              _this.loading = false;
            case 5:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    searchEvent: function searchEvent() {
      this.searchInfo.sdate = this.formData[0];
      this.searchInfo.edate = this.formData[1];
      this.loadTatleData();
    },
    open2: function open2() {
      this.$notify({
        title: "老用户",
        message: "数据列包括日期、老用户数、老用户次留、3留、4留、5留、6留、7留。",
        duration: 0
      });
    },
    getSummaries: function getSummaries(param) {
      var _this2 = this;
      var columns = param.columns;
      var sums = [];
      columns.forEach(function (column, index) {
        if (index === 0) {
          sums[index] = "合计";
          return;
        }
        if (column.property == "old_role") {
          sums[index] = _this2.tableDataCount[column.property];
          return;
        }
        var activity = _this2.tableDataCount[column.property];
        var newRole = _this2.rspData.expectUserCount["new_user_expect_" + column.property];
        var activityDivNewRole = newRole > 0 ? _this2.cal.toDecimal2(activity / newRole * 100) + "%" : "-";
        sums[index] = activity + "(" + activityDivNewRole + ")";
      });
      return sums;
    }
  }
};